<!--
 @name首页-校友风采模块
-->
<template>
  <div class="cont-item">
    <div class="title-image">
      <img src="../../assets/images/alumni-title.png" alt=""/>
    </div>
    <!-- 校友风采列表 -->
    <div v-for="(item, index) in itemList" :key="index" class="item" @click="handleAlumniStyle(item)">
      <div class="item-image">
        <img :src="imgUrl + item.mainPic + '&type=thumb'" alt="">
      </div>
      <div class="item-text">
        <p class="item-title ellipsis2">{{ item.informationTitle }}</p>
        <p class="item-date">{{ item.createTime  | dateFmt('YYYY-MM-DD')  }}</p>
      </div>
    </div>
    <div class="more-text" @click="showMoreAlumni">
      <p>更多校友风采</p>
    </div>
    <!-- 校友风采列表 -->
  </div>
</template>

<script>
import {getAlumniInformation} from "@/apis/apis"

export default {
  data() {
    return {
      imgUrl: "http://file.hainayx.com/file-server/download?fileUrl=",
      itemList: [] // 校友风采数据列表
    };
  },
  methods: {
    /** 获取校友风采数据请求接口 */
    async getAlumniInformationList() {
      try {
        let params = {
          pageNum: 1,
          pageSize: 3,
          status: 1
        };
        let {data} = await getAlumniInformation(params);
        if (data.code === 1000) {
          this.itemList = data.data.content;
        }
      } catch (error) {
        console.error('Failed to fetch news items:', error);
      }
    },
    /** 跳转详情页 */
    handleAlumniStyle(item) {
      console.log('Show more news');
      this.$router.push({
        name: "alumniDetail",
        query: {
          id: item.id
        }
      });
    },
    /** 跳转校友风采列表页面*/
    showMoreAlumni() {
      this.$router.push({
        name: "alumniStyle"
      });
      console.log('Show more news');
    }
  },
  mounted() {
    this.getAlumniInformationList();
  }
};
</script>

<style scoped lang="less">
.cont-item {
  padding: 60px 16px 16px 16px;

  .title-image {
    text-align: center;

    img {
      width: 301px;
      height: 100%;
      padding-bottom: 52px;
    }
  }

  .item {
    display: flex;
    justify-content: space-between;
    padding: 28px 0;
    border-bottom: 2px solid #DDDDDD;

    .item-image {
      width: 228px;
      height: 150px;
      margin-right: 36px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }

    .item-text {
      flex: 1;

      .item-title {
        font-size: 29px;
        color: #333333;
        line-height: 46px;
        margin-bottom: 28px;
      }

      .item-date {
        font-size: 24px;
        color: #999999;
        line-height: 26px;
      }
    }
  }

  .more-text {
    text-align: center;
    margin-top: 30px;

    p {
      font-size: 26px;
      color: #E58111;
      //width: 137px;
      padding: 0 20px;
      height: 57px;
      line-height: 57px;
      border-radius: 6px;
      border: 1px solid #E58111;
      display: inline-block;
      margin: 0 auto;
    }
  }
}

.ellipsis1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.ellipsis2 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.more-news {
  text-align: center;
  margin-top: 16px;
  color: #ff6700;
  border: 1px solid #ff6700;
  padding: 8px 16px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/AlumniStyle.vue